/**
 * Companies API Service
 */

import http from '../client';
import { ENDPOINTS } from '../config';

/**
 * Get list of companies with active assessments (public endpoint)
 * Returns companies with: id, name, description, photoUrl, assessmentCount
 * @returns {Promise<Object>}
 */
export const getAssessmentCompanies = async () => {
  try {
    const response = await http.get(ENDPOINTS.ASSESSMENT_COMPANIES.LIST, null, { skipAuth: true });
    return response;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Get list of companies with active+posted assessment count and benefits (public endpoint)
 * Returns companies with: id, name, photoUrl, assessmentCount (isActive=true AND isPost=true), companyBenefits, companyAdvantages
 * Used by /companies page
 * @returns {Promise<Object>}
 */
export const getCompaniesWithBenefits = async (country) => {
  try {
    const params = country ? { country } : null;
    const response = await http.get(ENDPOINTS.ASSESSMENT_COMPANIES.LIST_WITH_BENEFITS, params, { skipAuth: true });
    return response;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Get list of companies
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number
 * @param {number} params.limit - Items per page
 * @param {string} params.search - Search query
 * @param {string} params.industry - Industry filter
 * @param {string} params.size - Company size filter
 * @returns {Promise<Object>}
 */
/**
 * Names of every company registered in the system, for autocomplete.
 *
 * Returns a plain array of strings — this is the one company endpoint that actually
 * exists for this purpose (`/v1/company/names`). Requires auth.
 * @returns {Promise<{success: boolean, data?: string[], error?: string}>}
 */
export const getCompanyNames = async () => {
  try {
    const response = await http.get(ENDPOINTS.COMPANIES.NAMES);
    return response;
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export default {
  getAssessmentCompanies,
  getCompaniesWithBenefits,
  getCompanyNames
};
